import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { useMutation, useQuery } from "@apollo/client";
import { Bookmark_QB, Result_Submit } from "../../gql/mutation";
import { Get_server_time, Get_test } from "../../gql/queries";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import moment from "moment";
import {
  getResumeTestTime,
  getStatus,
  getTestPercentage,
  getTestTime,
} from "../../utils";
import { firebaseData } from "../../firebase";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { decrypt } from "../../utils/crypto";
import ConnectionError from "../common/NoDataFound/ConnectionError";
import { trackEvent } from "../../utils/moengageUserSetup";
export default function TestInstructions() {
  let { id } = useParams();
  const [proUserShow, setProUser] = useState(false);
  let localAttemtedQuestions = JSON.parse(localStorage.getItem(id))
    ? JSON.parse(localStorage.getItem(id))
    : []; // all attempted questions
  const ProUserHide = () => setProUser(false);
  const proShowUser = () => setProUser(true);
  const [config, setConfig] = useState();
  const [remoteLoading, setRemoteLoading] = useState(true);
  const [testResume, testshowResume] = useState(false);
  const showTestResume = () => testshowResume(true);
  const testHide = () => testshowResume(false);
  const [course, setCourse] = useState(
    JSON.parse(decrypt(localStorage.getItem("profileDetails")))
  );
  const location = useLocation();
  const naviagte = useNavigate();
  const time = (data) => {
    localStorage.setItem("time", data);
  };
  const [isLoading, setIsLoading] = useState(false);

  const [resultSubmit] = useMutation(Result_Submit, {
    refetchQueries: [
      {
        query: Get_test,
        variables: {
          _id: id,
        },
      }, // DocumentNode object parsed with gql
      "test", // Query name,
    ],
  });
  const [getBookmark] = useMutation(Bookmark_QB, {
    refetchQueries: [
      {
        query: Get_test,
        variables: {
          _id: id,
        },
      }, // DocumentNode object parsed with gql
      "test", // Query name,
    ],
  });
  const query2 = useQuery(Get_server_time);
  const query1 = useQuery(Get_test, {
    variables: {
      _id: id,
    },

    onCompleted: (data) => {
      trackEvent("viewTest", { "category": data.test.category, "content_id": id })
    },
  });
  const startTest = () => {
    // localStorage.setItem('testId',id)
    // query2.refetch()
    // if(!query2.loading && query2?.data?.serverTime){
    //     resultSubmit({ variables: { resultInput: { qbId: query1?.data?.test?._id, resultType: "Test", startTime: query2?.data?.serverTime, endTime: "0", duration: 0.0, questions: [], questionInterval: 0.0, category: query1?.data?.test?.category, isCompleted: false, subjectId: query1.data.test.subject, topicId: query1?.data?.test?.subjectDetail?.topicId, courseName: course.preparingFor } } })
    // }
  };
  // resultSubmit({ variables: {resultInput:{ qbId: query1?.data?.test?._id, resultType: "Test", startTime:query2?.data?.serverTime,endTime:"0",duration:0.0,questions:[],questionInterval:0.0,category:query1?.data?.test?.category,isCompleted:false,subjectId: query1.data.test.subject, topicId: query1?.data?.test?.subjectDetail?.topicId, courseName: course.preparingFor } }})
  // let resumeTime
  const getResumeTestTime = (duration, server, start) => {
    const startdateTime = new Date(start);
    const serverdateTime = new Date(server);
    const timeDifferenceInMilliseconds = serverdateTime - startdateTime;
    const totalduration = timeDifferenceInMilliseconds / 1000;
    let resumeTime = parseInt(duration * 60) - totalduration;
    // resumeTime = resumeTime
    return resumeTime;
  };

  const getResumeTime = (duration, server, start) => {
    const startdateTime = new Date(start);
    const serverdateTime = new Date(server);
    const timeDifferenceInMilliseconds = Math.abs(
      serverdateTime - startdateTime
    );
    const totalduration = timeDifferenceInMilliseconds / 1000;
    let resumeTime = parseInt(duration) - totalduration / 60;
    resumeTime = resumeTime * 60;
    resumeTime = parseInt(duration) * 60 - resumeTime;
    return resumeTime;
  };

  const showToastError = (message) => {
    toast.error(message);
  };
  const startTime = async (e) => {
    const response = await query2.refetch();
    localStorage.setItem("testId", id);
    if (!navigator.onLine) {
      showToastError("Please check your internet connection and try again");
      return;
    }
    if (query1?.error || query2?.error) {
      showToastError("Oops, an error has been occured and try again");
      return;
    }

    if (!query1.loading && !query2.loading) {
      localStorage.setItem("time", query1?.data?.test?.duration * 60);
      localStorage.setItem("start", JSON.stringify(query2?.data?.serverTime));
      let newquestionAttempt = [];
      localStorage.setItem(id, JSON.stringify(newquestionAttempt));
      trackEvent("viewTestAttempt", { "category": query1?.data?.test?.category, "content_id": query1?.data?.test?._id })
      // resultSubmit({ variables: { resultInput: { qbId: query1?.data?.test?._id, resultType: "Test", startTime: query1?.data?.test?.serverTime, endTime: "0", duration: 0.0, questions: [], questionInterval: 0.0, category: query1?.data?.test?.category, isCompleted: false, subjectId: query1.data.test.subject, topicId: query1?.data?.test?.subjectDetail?.topicId, courseName: course.preparingFor } } })
      //change server time to local time in utc in startTime
      resultSubmit({
        variables: {
          resultInput: {
            qbId: query1?.data?.test?._id,
            resultType: "Test",
            startTime: response?.data?.serverTime,
            endTime: "0",
            duration: 0.0,
            questions: [],
            questionInterval: 0.0,
            category: query1?.data?.test?.category,
            isCompleted: false,
            subjectId: query1.data.test.subject,
            topicId: query1?.data?.test?.subjectDetail?.topicId,
            courseName: course.preparingFor,
          },
        },
      });
      naviagte(`/testlayer/newTestattempt/${id}`);
    }
  };
  const resumeTime = async (e) => {
    if (!navigator.onLine) {
      showToastError("Please check your internet connection and try again");
      return;
    }
    if (query1?.error || query2?.error) {
      showToastError("Oops, an error has been occured and try again");
      return;
    }
    const response = await query2.refetch();
    if (response && response?.data) {
      let newquestionAttempt = [];
      let data;
      localAttemtedQuestions &&
        localAttemtedQuestions != null &&
        localAttemtedQuestions != undefined &&
        localAttemtedQuestions.map((obj1, i) => {
          if (obj1 !== null && obj1.questionId != "") {
            data = {
              userAnswer: obj1?.userAnswer,
              questionId: obj1?.questionId,
              isReview: obj1?.isReview,
              isGuessed: obj1?.isGuessed,
            };
            newquestionAttempt.push(data);
          }
        });
      time(
        getResumeTestTime(
          query1.data.test?.duration,
          response?.data?.serverTime,
          query1.data?.test?.progress?.startTime
        )
      );
      localStorage.setItem("testId", id);
      localStorage.setItem(
        "start",
        JSON.stringify(query1.data?.test?.progress?.startTime)
      );
      // console.log(parseFloat((getResumeTime(query1.data?.test?.duration,response?.data?.serverTime,query1.data?.test?.progress?.startTime)).toFixed(1)),"kileerjeet time")
      if (
        query1.data.test.duration * 60 <=
        parseFloat(
          getResumeTime(
            query1.data?.test?.duration,
            response?.data?.serverTime,
            query1.data?.test?.progress?.startTime
          ).toFixed(1)
        )
      ) {
        showTestResume();
        return;
      } else {
        if (query1?.error || query2?.error) {
          setIsLoading(true);
          return;
        }
        setIsLoading(false);
        resultSubmit({
          variables: {
            resultInput: {
              qbId: query1.data?.test?._id,
              resultType: "Test",
              startTime: query1.data?.test?.progress?.startTime,
              endTime: response?.data?.serverTime,
              duration: parseFloat(
                getResumeTime(
                  query1.data?.test?.duration,
                  response?.data?.serverTime,
                  query1.data?.test?.progress?.startTime
                ).toFixed(1)
              ),
              questions: newquestionAttempt,
              questionInterval: 0.0,
              category: query1.data.test.category,
              isCompleted: false,
              subjectId: query1.data.test.subject,
              topicId: query1.data.test.subjectDetail.topicId,
              courseName: course.preparingFor,
            },
          },
        });
        naviagte(`/testlayer/newTestattempt/${id}`, {
          state:
            query1.data && query1.data.test.progress.questions.length !== 0
              ? query1.data.test.progress.questions.length
              : localAttemtedQuestions?.length,
        });
      }
    }
    // let newquestionAttempt = []
    // query1.data.test.progress != undefined && query1.data.test.progress.questions.map((obj, i) => {
    //     query1.data.test != undefined && query1.data.test.questions.map((obj1, index) => {
    //         if ((obj.questionId).toString() == (obj1._id).toString()) {
    //             var filteredArray
    //             obj1.options.filter(function (obj2, indexes) {
    //                 if ((obj2._id).toString() == (obj.userAnswer).toString()) {
    //                     filteredArray = indexes
    //                 }
    //             });
    //             let data = {
    //                 "questionId": obj.questionId,
    //                 "answer": obj1.answer[0],
    //                 "userAnswer": obj.userAnswer,
    //                 "isReview": obj.isReview,
    //                 "isGuessed": obj.isGuessed,
    //                 "isAttempt": true,
    //                 "optionIndex": filteredArray
    //             }
    //             newquestionAttempt[i] = data
    //         }
    //     })
    // })
    // localStorage.setItem(id, JSON.stringify(newquestionAttempt));
  };
  useEffect(() => {
    if (!navigator.onLine) {
      showToastError("Please check yoyr internet connection , try again");
      return;
    }
    query1.refetch();
    getResumeTestTime(
      query1.data?.test?.duration,
      query2.data?.serverTime,
      query1.data?.test?.progress?.startTime
    );
  }, []);
  useEffect(() => {
    const getConfigData = async () => {
      try {
        const remoteData = await firebaseData("test_config"); // Replace 'your_config_key' with the actual key for the configuration value you want
        setConfig(JSON.parse(remoteData));
        setRemoteLoading(false);
        query1.refetch({ _id: id });
      } catch (error) {
        setRemoteLoading(false);
      }
    };

    if (typeof window !== "undefined") {
      getConfigData();
    }
  }, []);

  if (isLoading) {
    return (
      <>
        <div className="main_wrapper">
          <div className="col-lg-12">
            <ConnectionError pathName={location.pathname} />
          </div>
        </div>
      </>
    );
  }
  if (query1.loading || query2.loading)
    return (
      <>
        <Loader />
      </>
    );
  if (query1.error) {
    if (
      query1.error.graphQLErrors.some(
        (e) => e.extensions?.code === "UNAUTHENTICATED"
      )
    ) {
      //   history.push('/login');
      authorizationCheck(naviagte);
    } else if (
      query1.error.graphQLErrors.some(
        (e) => e.extensions?.code === "INTERNAL_SERVER_ERROR"
      )
    ) {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <SomethingWentWrong pathName={location.pathname} />
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <ConnectionError pathName={location.pathname} />
            </div>
          </div>
        </>
      );
    }
    //console.log(query1.error);
  }
  let newquestionAttempt = [];
  if (query1.data && query1.data.test.progress !== null) {
    query1.data &&
      query1.data.test &&
      query1.data.test.progress.questions.map((obj, i) => {
        let data = {
          questionId: obj.questionId,
          userAnswer: obj.userAnswer,
          isGuessed: obj.isGuessed,
          isReview: obj.isReview,
        };
        newquestionAttempt.push(data);
      });
  }
  const totalresult = async () => {
    const response = await query2.refetch();
    if (response && response?.data) {
      localStorage.removeItem(query1.data.test._id);
      localStorage.removeItem(`test${query1.data.test._id}`);
      resultSubmit({
        variables: {
          resultInput: {
            qbId: query1.data.test._id,
            resultType: "Test",
            startTime: query1.data.test.progress.startTime,
            endTime: response?.data?.serverTime,
            duration: query1.data?.test?.progress?.duration,
            questions: newquestionAttempt,
            questionInterval: 0.0,
            category: query1.data.test.category,
            isCompleted: true,
            subjectId: query1.data.test.subject,
            topicId: query1.data.test.subjectDetail.topicId,
            courseName: course.preparingFor,
          },
        },
      });
      naviagte(`/testlayer/testperformance/${query1.data.test._id}`);
    }
  };
  return (
    <>
      <div className="main_wrapper">
        <div className="breadcrumbs">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Home</a>
            </li>
            <li className="breadcrumb-item">
              <a>Test</a>
            </li>
            <li className="breadcrumb-item">
              <a>Test Category</a>
            </li>
            <li className="breadcrumb-item active">
              <a>{query1.data.test ? query1.data.test.title : ""}</a>
            </li>
          </ul>
        </div>
        <section className="videoLayer_wrapper qbanks_wrapper testInstruction_wrapper section_side_padding">
          <div className="row">
            <div className="col-lg-8 col-md-7 col-sm-12">
              <div className="topics_wrapper_main">
                <div className="subjects_wrapper topic_header">
                  <div className="topic_header_content d-flex align-items-center">
                    <div className="topic_image_ttl d-flex align-items-baseline">
                      {location?.state === "bookmark" && (
                        <figure className="back_arrow">
                          <Link to={`/account/mybookmarks`}>
                            <img
                              src={Icons.BackArrow}
                              alt="Back Arrow"
                              className="img-fluid"
                            />
                          </Link>
                        </figure>
                      )}
                      {location?.state !== "bookmark" && (
                        <figure className="back_arrow">
                          <Link
                            to={`/testlayer/${query1.data ? query1.data.test.category : "All"
                              }`}
                            state={config?.testLanding.category.years}
                          >
                            <img
                              src={Icons.BackArrow}
                              alt="Back Arrow"
                              className="img-fluid"
                            />
                          </Link>
                        </figure>
                      )}
                      <figure className="subject_inner_img">
                        <img
                          src={Images.Qbmark}
                          alt="Subject Image"
                          className="img-fluid"
                        />
                        <span className="text_qb">Test</span>
                      </figure>
                      <div className="subject_ttl_detail qbanks_ttl_details">
                        <h5>{query1.data ? query1.data.test.title : ""}</h5>
                        <div className="help_wrapper d-flex align-items-center">
                          <p>
                            <img
                              src={Icons.HelpCircle}
                              alt="Help"
                              className="img-fluid"
                            />
                            <span className="ttl_questions">
                              {query1.data.test &&
                                query1.data.test.questions.length}{" "}
                              Questions
                            </span>
                          </p>
                          <p className="clock_timer">
                            <img
                              src={Icons.Clock}
                              alt="Help"
                              className="img-fluid"
                            />
                            <span className="ttl_questions">{`${getTestTime(
                              query1.data && query1.data.test
                            )}`}</span>
                          </p>
                        </div>
                        {getStatus(query1.data.test) != "expire" &&
                          getTestPercentage(query1.data.test) != "100" &&
                          getStatus(query1.data.test) !== "upcoming" && (
                            <div className="expire_test">
                              <p>
                                Expires:{" "}
                                <span>
                                  {moment(query1.data?.test?.endTest).format(
                                    "DD MMM, hh:mm:ss A"
                                  )}
                                </span>
                              </p>
                            </div>
                          )}
                        {getStatus(query1.data.test) == "expire" &&
                          getTestPercentage(query1.data.test) != "100" &&
                          getStatus(query1.data.test) !== "upcoming" && (
                            <div className="expire_test">
                              <p>
                                Expired on:{" "}
                                <span>
                                  {moment(query1.data?.test?.endTest).format(
                                    "DD MMM, hh:mm:ss A"
                                  )}
                                </span>
                              </p>
                            </div>
                          )}
                        {getTestPercentage(query1.data.test) == "100" &&
                          getStatus(query1.data.test) !== "upcoming" && (
                            <div className="expire_test">
                              <p>
                                Completed:{" "}
                                <span>
                                  {moment(
                                    query1.data?.test?.progress?.endTime
                                  ).format("DD MMM, hh:mm:ss A")}
                                </span>
                              </p>
                            </div>
                          )}
                        {getStatus(query1.data.test) === "upcoming" && (
                          <div className="expire_test">
                            <p>
                              Upcoming:{" "}
                              <span>
                                {moment(query1.data?.test?.schedule).format(
                                  "DD MMM, hh:mm:ss A"
                                )}
                              </span>
                            </p>
                          </div>
                        )}
                        <div className="bookmarks_share">
                          {query1.data && query1.data.test.progress == null && (
                            <span
                              onClick={() =>
                                getBookmark({
                                  variables: {
                                    resultId: query1.data.test.progress
                                      ? query1.data.test.progress._id
                                      : "",
                                    qbId: query1.data.test._id,
                                    resultType: "Test",
                                    questionId: "",
                                    subjectId: query1.data.test.subject,
                                    courseName: "NEET PG Program",
                                    status: true,
                                  },
                                })
                              }
                            >
                              <img
                                src={Icons.Bookmark}
                                alt=""
                                className="img-fluid"
                              />{" "}
                              Bookmark Test
                            </span>
                          )}
                          {query1.data &&
                            query1.data.test.progress != null &&
                            query1.data &&
                            query1.data.test.progress.isBookMarked !== true && (
                              <span
                                onClick={() =>
                                  getBookmark({
                                    variables: {
                                      resultId: query1.data.test.progress
                                        ? query1.data.test.progress._id
                                        : "",
                                      qbId: query1.data.test._id,
                                      resultType: "Test",
                                      questionId: "",
                                      subjectId: query1.data.test.subject,
                                      courseName: "NEET PG Program",
                                      status: true,
                                    },
                                  })
                                }
                              >
                                <img
                                  src={Icons.Bookmark}
                                  alt=""
                                  className="img-fluid"
                                />{" "}
                                Bookmark Test
                              </span>
                            )}
                          {query1.data &&
                            query1.data.test.progress != null &&
                            query1.data.test.progress &&
                            query1.data.test.progress.isBookMarked === true && (
                              <span
                                onClick={() =>
                                  getBookmark({
                                    variables: {
                                      resultId: query1.data.test.progress
                                        ? query1.data.test.progress._id
                                        : "",
                                      qbId: query1.data.test._id,
                                      resultType: "Test",
                                      questionId: "",
                                      subjectId: query1.data.test.subject,
                                      courseName: "NEET PG Program",
                                      status: false,
                                    },
                                  })
                                }
                              >
                                <img
                                  src={Icons.unBookmark}
                                  alt=""
                                  className="img-fluid"
                                />{" "}
                                Bookmark Test
                              </span>
                            )}
                          {/* <span>
                                                        <img src={Icons.ShareBlue} alt="" className="img-fluid" /> Share Test
                                                    </span> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="recommended_video_wrapper instructions_wrapper">
                  <div className="instruction_header">
                    <h6>
                      <img
                        src={Icons.Instructions}
                        alt=""
                        className="img-fluid"
                      />
                      Instructions
                    </h6>
                  </div>
                  <div className="instructions_details">
                    <ul type="none" className="instruction_list">
                      <li>
                        <div className="ins_list_content d-flex align-items-baseline">
                          {/* <div className="inst_counts">
                                                    <span>1</span>
                                                </div> */}
                          <div
                            className="ins_texts"
                            dangerouslySetInnerHTML={{
                              __html: `${query1.data ? query1.data.test.instructions : ""
                                }`,
                            }}
                          >
                            {/* <p>Lörem ipsum diligt pören speling, i neng. Jaskade sydärar ditt i remalogi infrad. Fall deska gävör.</p> */}
                          </div>
                        </div>
                      </li>
                      {/* <li>
                                            <div className="ins_list_content d-flex align-items-baseline">
                                                <div className="inst_counts">
                                                    <span>2</span>
                                                </div>
                                                <div className="ins_texts">
                                                    <p>Lörem ipsum diligt pören speling, i neng. Jaskade sydärar ditt i remalogi infrad. Fall deska gävör.</p>
                                                </div>
                                            </div>  
                                        </li>
                                        <li>
                                            <div className="ins_list_content d-flex align-items-baseline">
                                                <div className="inst_counts">
                                                    <span>3</span>
                                                </div>
                                                <div className="ins_texts">
                                                    <p>Lörem ipsum askstoppad prer operaosmos. Såhyren mikrofäsk inte jängar, det tysäv, i biodiktiga huruvida osira. Vimism dev otyn spepogt. Makromick fakakant, uktiga predesk. Vötihor autora sinysm och bengar, kasåpp anar.</p>
                                                </div>
                                            </div>  
                                        </li>
                                        <li>
                                            <div className="ins_list_content d-flex align-items-baseline">
                                                <div className="inst_counts">
                                                    <span>4</span>
                                                </div>
                                                <div className="ins_texts">
                                                    <p>Lörem ipsum askstoppad prer operaosmos. Såhyren mikrofäsk inte jängar, det tysäv, i biodiktiga huruvida osira. Vimism dev otyn spepogt. Makromick fakakant, uktiga predesk. Vötihor autora sinysm och bengar, kasåpp anar.</p>
                                                </div>
                                            </div>  
                                        </li> */}
                    </ul>
                  </div>
                </div>
                <div className="select_timer_wrapper">
                  {query1.data &&
                    query1.data.test.purchaseStatus !== 0 &&
                    getStatus(query1.data.test) !== "upcoming" &&
                    ((query1.data.test && query1.data.test.progress === null) ||
                      (query1.data.test.progress &&
                        query1.data.test.progress.isCompleted !== true)) && (
                      <div
                        className="attempt_btn lock_attempt text-center"
                        onClick={proShowUser}
                      >
                        <button type="button" className="btn btn_theme">
                          <img
                            src={Icons.Arrowfade}
                            alt="Arrow fade"
                            className="img-fluid"
                          />{" "}
                          Attempt Now
                        </button>
                      </div>
                    )}

                  {query1.data &&
                    query1.data.test.purchaseStatus !== 0 &&
                    getStatus(query1.data.test) === "upcoming" &&
                    ((query1.data.test && query1.data.test.progress === null) ||
                      (query1.data.test.progress &&
                        query1.data.test.progress.isCompleted !== true)) && (
                      <div
                        className="attempt_btn lock_attempt text-center"
                        onClick={proShowUser}
                      >
                        <p>
                          you can attempt this test on{" "}
                          {moment(
                            query1.data && query1.data.test.schedule
                          ).format("DD MMM YYYY")}{" "}
                          ,{" "}
                          {moment(
                            query1.data && query1.data.test.schedule
                          ).format("hh:mm a")}
                        </p>
                        <button type="button" className="btn btn_theme">
                          <img
                            src={Icons.Arrowfade}
                            alt="Arrow fade"
                            className="img-fluid"
                          />{" "}
                          Attempt Now
                        </button>
                      </div>
                    )}
                  {query1.data.test &&
                    query1.data.test.purchaseStatus === 0 &&
                    getStatus(query1.data.test) != "upcoming" &&
                    (query1.data.test && query1.data.test.questions.length) ===
                    0 &&
                    ((query1.data && query1.data.test.progress === null) ||
                      (query1.data.test.progress &&
                        query1.data.test.progress.isCompleted === null)) &&
                    (getResumeTestTime(
                      query1.data && query1.data?.test?.duration,
                      query2.data && query2?.data?.serverTime,
                      query1.data && query1.data.test?.progress?.startTime
                    ) < 0 ||
                      getResumeTestTime(
                        query1.data && query1.data?.test?.duration,
                        query2.data && query2?.data?.serverTime,
                        query1.data && query1.data.test?.progress?.startTime
                      ) === 0) && (
                      <div className="attempt_btn text-center">
                        <button
                          type="button"
                          className="btn btn_theme"
                          onClick={showTestResume}
                        >
                          Attempt Now
                        </button>
                      </div>
                    )}

                  {query1.data.test &&
                    query1.data.test.purchaseStatus === 0 &&
                    ((query1.data && query1.data.test.progress === null) ||
                      (query1.data.test.progress &&
                        query1.data.test.progress.isCompleted === null)) &&
                    getStatus(query1.data.test) != "upcoming" &&
                    (query1.data.test && query1.data.test.questions.length) >
                    0 && (
                      <div className="attempt_btn text-center">
                        {/* <Link to={`/testlayer/newTestattempt/${id}`} state={'0'} onClick={() => time(query1.data.test.duration * 60)}>
                                                <button type="button" className="btn btn_theme" onClick={(e) => startTime(e)} >Attempt Now</button>
                                            </Link> */}
                        <button
                          type="button"
                          className="btn btn_theme"
                          onClick={(e) => startTime(e)}
                        >
                          Attempt Now
                        </button>
                      </div>
                    )}
                  {query1.data &&
                    query1.data.test.progress !== null &&
                    query1.data.test.progress &&
                    query1.data.test.progress.isCompleted === false &&
                    getStatus(query1.data.test) !== "upcoming" &&
                    getResumeTestTime(
                      query1.data.test?.duration,
                      query2?.data?.serverTime,
                      query1.data?.test?.progress?.startTime
                    ) > 0 && (
                      <div
                        className="attempt_btn text-center"
                        onClick={(e) => resumeTime(e)}
                      >
                        <p>
                          At Question:{" "}
                          <span>
                            {query1.data.test.progress &&
                              query1.data.test.progress.questions.length}
                          </span>
                        </p>
                        {/* <Link to={`/testlayer/testattempt/${id}`} state={query1.data && query1.data.test.progress.questions.length !== 0 ? query1.data.test.progress.questions.length : localAttemtedQuestions?.length}> */}
                        <button type="button" className="btn btn_theme">
                          Resume test
                        </button>
                        {/* </Link> */}
                      </div>
                    )}
                  {query1.data &&
                    query1.data.test.progress !== null &&
                    query1.data.test.progress &&
                    query1.data.test.progress.isCompleted === false &&
                    getStatus(query1.data.test) !== "upcoming" &&
                    (getResumeTestTime(
                      query1.data.test?.duration,
                      query2?.data?.serverTime,
                      query1.data.test.progress.startTime
                    ) < 0 ||
                      getResumeTestTime(
                        query1.data.test?.duration,
                        query2?.data?.serverTime,
                        query1.data.test.progress.startTime
                      ) === 0) && (
                      <div className="attempt_btn text-center">
                        {/* <p>At Question: <span>{query1.data.test.progress && query1.data.test.progress.questions.length + 1}</span></p> */}
                        <button
                          type="button"
                          className="btn btn_theme"
                          onClick={showTestResume}
                        >
                          Resume test
                        </button>
                      </div>
                    )}
                  {query1.data.test &&
                    query1.data.test.progress !== null &&
                    query1.data.test.progress &&
                    query1.data.test.progress.isCompleted === true &&
                    getStatus(query1.data.test) != "upcoming" && (
                      <div className="attempt_btn text-center">
                        <Link to={`/testlayer/testperformance/${id}`}>
                          <button type="button" className="btn btn_theme">
                            Check Performance
                          </button>
                        </Link>
                      </div>
                    )}
                  {query1.data &&
                    query1.data.test.purchaseStatus === 0 &&
                    getStatus(query1.data.test) === "upcoming" && (
                      <div
                        className="attempt_btn lock_attempt text-center"
                        onClick={proShowUser}
                      >
                        <button type="button" className="btn btn_theme">
                          <img
                            src={Icons.Arrowfade}
                            alt="Arrow fade"
                            className="img-fluid"
                          />{" "}
                          Attempt Now
                        </button>
                      </div>
                    )}
                </div>
              </div>
            </div>

            {/* <div className="col-lg-4 col-md-4 col-sm-12">
                        
                    </div> */}
          </div>
        </section>
      </div>
      <Modal
        show={testResume}
        onHide={testHide}
        backdrop="static"
        className="detail_modal report_modal testReumse"
        centered
      >
        <Modal.Body>
          <div className="rating_modal_body text-center">
            <h5>Your time is out!</h5>
            <p>
              You cannot attempt this test now as you have run out of time.
              Click on View Performance to check your score
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="rating_submit">
            <button
              type="button"
              className="btn btn_theme btn_border"
              onClick={testHide}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn_theme"
              onClick={totalresult}
            >
              View Performance
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={proUserShow}
        onHide={ProUserHide}
        backdrop="static"
        className="detail_modal report_modal proUsers_modal"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <h4>Available for only Pro users</h4>
            <div className="cross_icon text-right">
              <img
                src={Icons.ModalCross}
                alt=""
                className="img-fluid"
                onClick={ProUserHide}
              />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="account_option_wrapper"> */}
          <div className="account_header text-center">
            <img src={Icons.LockPro} alt="" className="img-fluid" />
            {/* <h6>Account Deleted!!</h6> */}
            <p>
              This content is available for pro users only. Click on View Plans
              to checkout suitable plans to access this course
            </p>
          </div>
          {/* </div> */}
        </Modal.Body>
        <Modal.Footer>
          <div className="rating_submit">
            <button
              type="button"
              className="btn btn_theme btn_border"
              onClick={ProUserHide}
            >
              Cancel
            </button>
            <Link to={"/package/singleSubscription"} state={query1.data}>
              <button type="submit" className="btn btn_theme">
                View Plans
              </button>
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
